<template>
  <div class="tile">

    <div class="tile is-parent is-8">
      <!--              <article class="tile is-child box">-->
      <div class="tile is-child card " style="height: 80vh">
        <div class="card-content">

          <b-table size="is-small" :data="products_data" :loading="isFetching" :paginated="true" :per-page="10"
                   pagination-position="bottom" focusable @click="selectNewProduct" type="is-primary">
<!--            <b-table-column field="id" label="ID" width="40" searchable numeric v-slot="props">
              {{ props.row.id }}
            </b-table-column>-->
            <b-table-column width="50" field="code" label="Code" searchable v-slot="props">
              {{ props.row.code}}
            </b-table-column>
            <b-table-column field="rental_sales" width="50" label="Type" searchable v-slot="props">
              <b-tag size="is-small">{{ props.row.rental_sales}}</b-tag>
            </b-table-column>
            <b-table-column field="name" label="Description" searchable v-slot="props">
              {{ props.row.name }}
            </b-table-column>
            <b-table-column field="internal_remark" label="Internal remark" searchable v-slot="props">
              {{ strippedValue(props.row.internal_remark) }}
            </b-table-column>
            <b-table-column field="print" v-slot="props">
              <b-field>
                <p class="control">
                  <b-dropdown  :triggers="['hover']" aria-role="list">
                    <template #trigger>
                      <b-button
                          size="is-small"
                          label=""
                          icon-right="eye" />
                    </template>
                    <b-dropdown-item aria-role="listitem"  @click="previewProduct(props.row, 'small')">Small</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem"  @click="previewProduct(props.row, 'large')">Large</b-dropdown-item>
                  </b-dropdown>
                </p>
                <p class="control">
                  <b-dropdown :triggers="['hover']" aria-role="list">
                    <template #trigger>
                      <b-button
                          size="is-small"
                          label=""
                          icon-right="printer" />
                    </template>
                    <b-dropdown-item aria-role="listitem"  @click="printProduct(props.row, 'small')">Small</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem"  @click="printProduct(props.row, 'large')">Large</b-dropdown-item>
                  </b-dropdown>
                </p>
              </b-field>
            </b-table-column>
          </b-table>


        </div>
      </div>
    </div>

    <div class="tile is-parent is-4 is-vertical">
      <div class="tile is-child card" style="flex: none" >
        <div class="card-content">
          <b-field grouped>
            <b-field
                label="Amount"
                type="is-primary">
              <b-select size="is-small" v-model="amountOfLabels">
                <option :value="1">1</option>
                <option :value="2">2</option>
                <option :value="3">3</option>
                <option :value="4">4</option>
                <option :value="5">5</option>
                <option :value="6">6</option>
                <option :value="7">7</option>
                <option :value="8">8</option>
              </b-select>
            </b-field>
            <b-field label="Print">
              <b-button size="is-small" :disabled="checkedAssets.length <= 0" @click="printSerial(null, 'small')">
                Print Tags ({{ checkedAssets.length }})
              </b-button>
            </b-field>
          </b-field>
        </div>
      </div>
      <div class="tile is-child card" style="min-height:0; overflow:auto;" >

        <div class="card-content">

          <b-table :data="serials_data" :checked-rows.sync="checkedAssets" :loading="isFetching" checkable>
<!--            <b-table-column field="id" width="50" label="ID" searchable v-slot="props">-->
<!--              {{ props.row.id }}-->
<!--            </b-table-column>-->
            <b-table-column field="ref" label="Asset Tag (ref)" v-slot="props" searchable>
              {{ props.row.ref }}
            </b-table-column>
            <b-table-column field="remark" label="Remark" v-slot="props" searchable>
              {{ strippedValue(props.row.remark) }}
            </b-table-column>
            <b-table-column field="print" v-slot="props">
              <b-field>
                <p class="control">
                  <b-dropdown  :triggers="['hover']" aria-role="list">
                    <template #trigger>
                      <b-button
                          @click="previewSerial(props.row, 'small')"
                          size="is-small"
                          label=""
                          icon-right="eye" />
                    </template>
                  </b-dropdown>
                </p>
                <p class="control">
                  <b-dropdown :triggers="['hover']" aria-role="list">
                    <template #trigger>
                      <b-button
                          @click="printSerial(props.row, 'small', true)"
                          size="is-small"
                          label=""
                          icon-right="printer" />
                    </template>
                  </b-dropdown>
                </p>
              </b-field>
            </b-table-column>
          </b-table>

        </div>
      </div>
    </div>
  </div>
</template>

<script >
import {fetchAuthSession} from "aws-amplify/auth";
import axios from "axios";
import moment from "moment/moment";

export default {
  data() {
    return {
      amountOfLabels: 1,

      // Database
      isFetching: true,
      selectedDB: "products-rem",
      serials_data: [],
      checkedAssets: [],

      // PRODUCTS
      selectedProduct: null,
      products_data: [],

    };
  },

  mounted() {
    this.getProducts();
  },

  computed: {

  },

  methods: {

    strippedValue(field) {
      return new DOMParser().parseFromString(field, 'text/html').body.textContent;
    },

    async getProducts() {

      this.$buefy.notification.open({
        indefinite: true,
        message: 'As a temporary workaround, you need to enable WS insecure (runs over VPN anyway). Press the settings of this page next to URL, then Site Settings, and change the value of Insecure content to Allow for this site.',
        position: "is-bottom-right",
        type: 'is-warning',
      })

      const session = await fetchAuthSession()
      const token = session.tokens.idToken.toString()

      this.isFetching = true
      let thisIns = this;
      await axios.get(`https://3ps17el2ce.execute-api.eu-central-1.amazonaws.com/dev/productsrm`, {
        headers: {
          'Authorization': token
        },
      })
          .then(function (response) {
            thisIns.isFetching = false
            thisIns.products_data = response.data.body;
          })
          .catch((error) => {
            console.log(error)
            thisIns.$buefy.notification.open({
              message: error,
              type: 'is-danger'
            })
          })
          .finally(() => {
            thisIns.isFetching = false
          })

    },

    async selectNewProduct(data) {
      var product = null
        product = data
        this.selectedProduct = product


      const session = await fetchAuthSession()
      const token = session.tokens.idToken.toString()

      this.checkedAssets = []

      this.isFetching = true
      let thisIns = this;
      await axios.get(`https://3ps17el2ce.execute-api.eu-central-1.amazonaws.com/dev/productsrm/${product.id}/`, {
        headers: {
          'Authorization': token
        },
      })
          .then(function (response) {
            thisIns.isFetching = false
            thisIns.serials_data = response.data.body;

          })
          .catch((error) => {
            console.log(error)
            thisIns.$buefy.notification.open({
              message: error,
              type: 'is-danger'
            })
          })
          .finally(() => {
            thisIns.isFetching = false
          })

    },


    previewSerial(serial, size) {
      if (size === "small") {
        this.$emit("previewZPL", this.generateSerialLabelZPLSmall(
            this.selectedProduct.name,
            this.strippedValue(serial.remark),
            serial.ref,
            serial.qrcodes

        ), "2.76x1.26")
      }
    },
    printSerial(serial, size, single=false) {
      let res = []
      let assetsToPrint = this.checkedAssets
      let amount = this.amountOfLabels
      if (single) {
        this.amountOfLabels = 1;
        assetsToPrint = [serial]
      }

      assetsToPrint.forEach(asset => {
        for (let i = 0; i < amount; i++) {
          if(size === "small") {
            res.push(this.generateSerialLabelZPLSmall(
                this.selectedProduct.name,
                this.strippedValue(asset.remark),
                asset.ref,
                asset.qrcodes
            ))
          }
        }
      })
      this.$emit("printZPL", res)
    },

    previewProduct(product, size) {
      if(size === "large") {
        this.$emit("previewZPL", this.generateProductLabelZPLLarge(
            product.code,
            product.qrcodes,
            product.name,
            this.strippedValue(product.internal_remark),
            product.rental_sales), "4.02x3")
      }
      if(size === "small") {
        this.$emit("previewZPL", this.generateProductLabelZPLSmall(
            product.code,
            product.qrcodes,
            product.name,
            this.strippedValue(product.internal_remark),
            product.rental_sales), "2.76x1.26")
      }
    },

    printProduct(product, size) {

      let res = []
      for (let i = 0; i < this.amountOfLabels; i++) {
        if(size === "large") {
          res.push(this.generateProductLabelZPLLarge(
              product.code,
              product.qrcodes,
              product.name,
              this.strippedValue(product.internal_remark),
              product.rental_sales))
        }
        if(size === "small") {
          res.push(this.generateProductLabelZPLSmall(
              product.code,
              product.qrcodes,
              product.name,
              this.strippedValue(product.internal_remark),
              product.rental_sales))
        }
      }
      this.$emit("printZPL", res)

    },

    generateProductLabelZPLLarge(code, qr, description, remark, type) {
      var currentDate = moment().format('DD/MM/YYYY');
      return `^XA ^CI27
              ^PW832
              ^CF0,30^FO50,70
              ^FD${qr}^FS
              ^CF0,30^FO650,70
              ^FD${type}^FS
              ^CF0,55^FO50,125^FB730,3,5,L,0^FD${description}^FS
              ^CF0,25 ^FO50,310^FB730,3,5,L,0^FD${remark}^FS
              ^CF0,40^FO320,410^BQN,2,6 ^FDQA,${qr}^FS
              ^BY4,2,30
              ^XZ`
    },
    generateProductLabelZPLSmall(code, qr, description, remark, type) {
      var currentDate = moment().format('DD/MM/YYYY');
      return `^XA ^CI27 ^PW560
              ^FO476,20^GFA,2400,2400,10,,:::::::U0F,T07FC,S03IF,U03F,V078,V03C,W0C,W04,Q02K02,Q04,Q08,P018,P03,P07,:P0F,::::P07,:P03,P038,P018,Q0C,Q02K02,W04,W0C,V01C,V078,U01F8,S03IF,T0FFE,T01F8,,:::::::::::S0FE,R03FF8,R07C7C,R0F01E,Q01C007,Q018003,Q0380038,:Q03I018,:::Q0380038,:Q01C007,:R08002,,::::::::Q03IF8,Q03IFC,Q03JF,,:::::::U018,:::::U038,Q03JF8,:U038,U018,:::::,::::V08,U038,U078,T01F,T03C,T0F8,S03E,S078,Q03FF,:S078,S01E,T0F8,T03C,U0F,U078,U018,,:::::::Q03JF8,::T01F,T07C,T0F,S03C,S0F8,S06,,:R018,R01E,S0F8,S03C,T0F,T07C,T01E,Q03JF8,::,::::::::::Q03JF8,:Q0383838,Q0301818,::::::::Q03I018,Q01,,:::::::Q01C07C,Q0180FE,Q0380FF,Q0381C38,Q0301838,Q0301818,Q0303818,:Q0303018,Q0307018,Q0387038,Q01FE03,:R078,,::::::::Q03JF8,::S038,S018,::::::::S038,Q03JF8,::,:::::::^FS
              ^CFB,12 ^FO182,20^FD${type}^FS
              ^CF0,26 ^FO180,40^FB325,2,4,L,0^FD${description}^FS
              ^CF0,22 ^FO180,105^FB320,3,5,L,0^FD${remark}^FS
              ^CF0,15 ^FO362,176^FDprinted on ${currentDate}^FS
              ^FO20,20 ^BQN,2,6 ^FDQA,${qr}^FS
              ^LRY ^CF0,45,50 ^FO20,210^FD${qr}^FS
              ^LRN ^XZ`
    },

    generateSerialLabelZPLSmall(productname, productdesc, serialkey, qr) {
      var currentDate = moment().format('DD/MM/YYYY');
      return `^XA ^CI27 ^PW560
              ^FO476,20^GFA,2400,2400,10,,:::::::U0F,T07FC,S03IF,U03F,V078,V03C,W0C,W04,Q02K02,Q04,Q08,P018,P03,P07,:P0F,::::P07,:P03,P038,P018,Q0C,Q02K02,W04,W0C,V01C,V078,U01F8,S03IF,T0FFE,T01F8,,:::::::::::S0FE,R03FF8,R07C7C,R0F01E,Q01C007,Q018003,Q0380038,:Q03I018,:::Q0380038,:Q01C007,:R08002,,::::::::Q03IF8,Q03IFC,Q03JF,,:::::::U018,:::::U038,Q03JF8,:U038,U018,:::::,::::V08,U038,U078,T01F,T03C,T0F8,S03E,S078,Q03FF,:S078,S01E,T0F8,T03C,U0F,U078,U018,,:::::::Q03JF8,::T01F,T07C,T0F,S03C,S0F8,S06,,:R018,R01E,S0F8,S03C,T0F,T07C,T01E,Q03JF8,::,::::::::::Q03JF8,:Q0383838,Q0301818,::::::::Q03I018,Q01,,:::::::Q01C07C,Q0180FE,Q0380FF,Q0381C38,Q0301838,Q0301818,Q0303818,:Q0303018,Q0307018,Q0387038,Q01FE03,:R078,,::::::::Q03JF8,::S038,S018,::::::::S038,Q03JF8,::,:::::::^FS
              ^CF0,26 ^FO180,30^FB325,2,4,L,0^FD${productname}^FS
              ^CF0,22 ^FO180,95^FB320,3,5,L,0^FD${productdesc}^FS
              ^CF0,15 ^FO362,156^FDprinted on ${currentDate}^FS
              ^CF0,15 ^FO240,176^FD events@citymesh.com | +32 14 40 45 95^FS
              ^FO20,20 ^BQN,2,6 ^FDQA,${qr}^FS
              ^FO0,195^GB500,90,90^FS
              ^LRY ^CF0,45,50 ^FO20,210^FD${serialkey}^FS
              ^LRN ^XZ`
    },

  },
};
</script>



<style scoped>

</style>